import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { ContentHolder } from "commons";
import { getRangeStringFromId, getDefaultAnalysisDateRange } from "commons/src/NuDateUtils";
import { IN_PROGRESS } from "commons/src/helpers/RequestHelpers";

import { Home } from "./Home";
import { requestObject } from "../../reducers/requestsActions";

const defaultRequestStatus = {
    status: IN_PROGRESS
};

function HomeContainerComponent({
    accounts,
    analysis,
    memoAssets,
    memoAssetsRequestStatus = defaultRequestStatus,
    portfolioPerformanceRequestStatus = defaultRequestStatus,
    accountsRequestStatus = defaultRequestStatus
}) {
    return (
        <ContentHolder>
            <Home
                accounts={accounts}
                memoAssets={memoAssets}
                analysis={analysis}
                accountsRequestStatus={accountsRequestStatus}
                memoAssetsRequestStatus={memoAssetsRequestStatus}
                portfolioPerformanceRequestStatus={portfolioPerformanceRequestStatus}
            />
        </ContentHolder>
    );
}

HomeContainerComponent.propTypes = {
    accounts: PropTypes.object,
    analysis: PropTypes.object,
    memoAssets: PropTypes.array,
    accountsRequestStatus: requestObject,
    memoAssetsRequestStatus: requestObject,
    portfolioPerformanceRequestStatus: requestObject
};

const mapStateToProps = state => {
    const filteredAnalysis = state.analysis[getRangeStringFromId(getDefaultAnalysisDateRange().id)];

    return {
        accounts: state.accounts || {},
        memoAssets: state.memoAssets.assets,
        analysis: filteredAnalysis,
        accountsRequestStatus: state.requests.accounts,
        memoAssetsRequestStatus: state.requests.memoAssets,
        portfolioPerformanceRequestStatus: state.requests.portfolioperformance
    };
};

export const HomeContainer = connect(mapStateToProps)(HomeContainerComponent);
